import { without } from 'ramda'
import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeApiTypes } from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('FETCH_INITIAL_SETUP', 'app'),
  ...makeApiTypes('FETCH_REVIEWS', 'app'),
  INIT_PUSH_NOTIFICATIONS: 'app/INIT_PUSH_NOTIFICATIONS',
  INIT_LAUNCH_DARKLY_USER: 'app/INIT_LAUNCH_DARKLY_USER',
}

export const fetchInitialSetup = flags => ({
  [RSAA]: {
    endpoint: getApiPath('auth', 'initialsetup'),
    headers: {
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
    method: 'GET',
    types: [
      types.FETCH_INITIAL_SETUP_REQUEST,
      {
        type: types.FETCH_INITIAL_SETUP_SUCCESS,
        meta: {
          flags,
        },
      },
      types.FETCH_INITIAL_SETUP_ERROR,
    ],
  },
})

export const fetchReviews = () => ({
  [RSAA]: {
    endpoint: getApiPath('acct', 'review/summary'),
    method: 'GET',
    headers: {
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
    types: [
      types.FETCH_REVIEWS_REQUEST,
      types.FETCH_REVIEWS_SUCCESS,
      types.FETCH_REVIEWS_ERROR,
    ],
  },
})

const initialState = {
  pushNotificationsReady: false,
  review: {
    busy: false,
    error: null,
    reviewInfo: {},
  },
  serviceArea: {
    busy: false,
    error: null,
    entities: [],
  },
  launchDarkly: {
    userInitialized: false,
  },
  timeOutInMinutes: 0,
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.INIT_PUSH_NOTIFICATIONS: {
      return { ...state, pushNotificationsReady: true }
    }

    case types.FETCH_INITIAL_SETUP_REQUEST: {
      return {
        ...state,
        serviceArea: {
          ...state.serviceArea,
          busy: true,
          error: null,
        },
      }
    }
    case types.FETCH_INITIAL_SETUP_SUCCESS: {
      // The following states no longer have an underwriter and not covered
      const removeUncoveredStates = without(['KY', 'MS', 'UT'])

      let coveredStates = removeUncoveredStates(payload.coveredStates)

      return {
        ...state,
        serviceArea: {
          ...state.serviceArea,
          busy: false,
          entities: coveredStates,
        },
        // No matter what the token expiration is set to, we will
        // set the timeout to 30 minutes. See AutoLogout component for
        // more details on how that 30 mins is used (hint: it's timers).
        timeOutInMinutes: 30,
      }
    }
    case types.FETCH_INITIAL_SETUP_ERROR: {
      return {
        ...state,
        serviceArea: {
          ...state.serviceArea,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    case types.INIT_LAUNCH_DARKLY_USER: {
      return {
        ...state,
        launchDarkly: {
          userInitialized: true,
        },
      }
    }

    case types.FETCH_REVIEWS_REQUEST: {
      return {
        ...state,
        review: {
          ...state.review,
          busy: true,
          error: null,
        },
      }
    }
    case types.FETCH_REVIEWS_SUCCESS: {
      return {
        ...state,
        review: {
          ...state.review,
          reviewInfo: payload,
          busy: false,
        },
      }
    }
    case types.FETCH_REVIEWS_ERROR: {
      return {
        ...state,
        review: {
          ...state.review,
          busy: false,
          error: 'Something went wrong with your request',
        },
      }
    }
    default:
      return state
  }
}
